import React, { useEffect, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./SetAvailablity.module.css";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Input } from "../../../../stories/Input/Input";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import CustomFullCalendar from "../../../../stories/CustomFullCalendar";
import { useHistory } from "react-router-dom";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import SetAvailablityMobile from "./SetAvailabilityMobile";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

function SetAvailablityDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(state => state.onBoardingReducer.setAvailability)

  const [intervalBetween, setIntervalBetween] = useState(getDataFromRedux?.intervalBetween ? getDataFromRedux?.intervalBetween : null);
  const [breakBetween, setbreakBetween] = useState(getDataFromRedux?.breakBetween ? getDataFromRedux?.breakBetween: null);
  const [checks, setChecks] = useState(getDataFromRedux?.checks ? getDataFromRedux?.checks :  []);
  const history = useHistory()

  function saveDataIntoRedux() {
    dispatch(setPersonalData('setAvailability', { checks, breakBetween, intervalBetween }))

  }




  return (
    <div className={`${[classes.setAvailability].join(" ")}`}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={'100%'} />
      </div>
      <Container fluid className={`p-0 ${classes.container} `}>
        <Row className={`g-0 ${[classes.row].join(" ")}`}>
          {/* Main Page */}
          <Col md={12} >
            <Container fluid className={classes.innerContainer}>
              <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
                <LinkButtonWithIcon
                  text={"Save and Finish Later"}
                  customStyle={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  onClick={saveDataIntoRedux}
                />
              </Col>
              {/* Main Page Data */}
              <Col md={12}>
                <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                  Set availability
                </h3>
                <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                  Select and drag to mark available hours
                </p>
              </Col>
              <Col md={12}>
                <div className={`${[classes.checkBoxes].join(" ")}`}>
                  <div
                    className={`${[classes.checkboxWithInput, classes.mb32].join(
                      " "
                    )}`}
                  >
                    <Checkbox
                      setValue={setChecks}
                      value={checks}
                      label={
                        "The interval between lessons in different locations should be"
                      }
                    />
                    <div style={{ position: 'relative' }}>

                      <Input
                        state={intervalBetween}
                        setter={setIntervalBetween}
                        customStyle={{ width: "100px", marginLeft: "24px" }}
                        inputStyle={{ paddingRight: "38px" }}
                        placeholder=""
                        type={'number'}
                      />
                      <span className={classes.postFixText} style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>min</span>
                    </div>
                  </div>
                  <div className={`${[classes.checkboxWithInput].join(" ")}`}>
                    <Checkbox
                      setValue={setChecks}
                      value={checks}
                      label={
                        "The break between lessons in one location should be"
                      }
                    />
                    <div style={{ position: 'relative' }}>
                      <Input
                        state={breakBetween}
                        setter={setbreakBetween}
                        customStyle={{ width: "100px", marginLeft: "24px" }}
                        type={'number'}
                        inputStyle={{ paddingRight: "38px" }}
                        placeholder=""
                      />
                      <span className={classes.postFixText} style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>min</span>
                    </div>
                  </div>
                </div>
              </Col>
              {/* Availability Table */}
              <Col md={12}>
                <div>
                  <CustomFullCalendar />
                </div>
              </Col>
            </Container>
          </Col>

          {/* Buttons Col */}
          <Col
            md={12}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
            className={classes.btnsCol}
          >
            <div className={classes.btnsBox}>
              <Button
                label={"Back"}
                size={"Large"}
                customStyle={{ width: "162px", height: "56px" }}
                onClick={() => {
                  stepForwardAndBackward(2, 4)
                }}

              />
              <Button
                label={"Next"}
                primary={true}
                size={"Large"}
                customStyle={{ width: "162px", height: "56px" }}
                onClick={() => {
                  saveDataIntoRedux()
                  history.push('/profile-preview')}}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default function SetAvailability({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, [])
  return isMobile ?
    <SetAvailablityMobile stepForwardAndBackward={stepForwardAndBackward} /> : <SetAvailablityDesktop stepForwardAndBackward={stepForwardAndBackward} />
}
